import loadable from '@loadable/component';

export const namespace = 'canalplus.block.parent_code.reset';
export const Component = loadable(
  () => import('./containers/ParentCodeResetContainer')
);
export { default as propsFormatter } from './propsFormatter';
